export default __webpack_public_path__ + "static/media/banner_pachacamac.9e0b4043.JPG";